import { FC, memo } from 'react'
import { Card, CardProps, Stack, HStack } from '@chakra-ui/react'

import { TextWithCharacterLimit } from 'components'
import {
  CustomFormCommonEntity,
  CustomFormCommonEntityFilterKeyString,
  CustomFormCommonEntityKeyString,
} from '../../components/Viewer/components/CustomFormViewerQuestion/components/CustomFormViewerQuestionSelection/components/CustomFormEntitiesQuestions/components/CustomFormCommonEntitySelectionDrawer/types'

type Props = CardProps & {
  entityFilter?: CustomFormCommonEntityFilterKeyString
  entity: CustomFormCommonEntity
}

const CustomFormCommonEntityCard: FC<Props> = ({ entity, entityFilter, children, ...cardProps }) => {
  function setEntityValueByKey(key: string): string {
    const entityWithKeyString: CustomFormCommonEntityKeyString = { ...entity }
    return (entityWithKeyString[`entity_${key}`] || entityWithKeyString[key]) as string
  }

  function setEntityFilterValueByKey(key: string): string {
    if (!entityFilter) return ''
    return entityFilter[`entity_${key}`] || entityFilter[key]
  }

  return (
    <Card
      position="relative"
      p={2}
      width="100%"
      height="100%"
      className="accessible"
      _hover={{ bg: 'lightPrimary' }}
      {...cardProps}
    >
      <Stack>
        <HStack>
          <Stack spacing={0}>
            <TextWithCharacterLimit fontSize="md" hasHighlight highlightQuery={setEntityFilterValueByKey('name')}>
              {setEntityValueByKey('name')}
            </TextWithCharacterLimit>

            {setEntityValueByKey('description') && (
              <TextWithCharacterLimit
                hasHighlight
                highlightQuery={setEntityFilterValueByKey('description')}
                variant="secondary"
              >
                {setEntityValueByKey('description')}
              </TextWithCharacterLimit>
            )}

            {setEntityValueByKey('state_name') && (
              <TextWithCharacterLimit
                hasHighlight
                highlightQuery={setEntityFilterValueByKey('description')}
                variant="secondary"
              >
                {setEntityValueByKey('state_name')}
              </TextWithCharacterLimit>
            )}
          </Stack>
        </HStack>

        {children}
        {/* <Box position="absolute" top={2} right={2}>
          <Checkbox size="md" />
        </Box> */}
      </Stack>
    </Card>
  )
}

export default memo(CustomFormCommonEntityCard)
